import ProfilePage from "../../pages/profile";
export var Profile_Routes = [
    {
        PATH: "/:username",
        COMPONENT: ProfilePage,
        isProtected: true,
    },
];
